import styled from 'styled-components';
import ContainerPage from '../../../../components/ContainerPage';
import { ActionButton } from '../../../../pages/ProductSelector/components/ActionButton';
import HeadTitle from '../../../../components/HeadTitle';
import React, { useState } from 'react';
import { ProductItemProps } from '../../../../models/Product';
import { Page, useCheckUpRouter } from '../../router/context';
import { ProductListMult } from '../../components/ProductListCheck';

const Container = styled.div`
  padding-bottom: 20px;
`;

export type ProductListPageProps = {
  service: any;
  patient: any;
  elegibility: any;
  firstAppointmentDate: string;
  isFirstAppointment: boolean;
};

export function ProductListPage({
  service,
  patient,
  elegibility,
  firstAppointmentDate,
  isFirstAppointment
}: ProductListPageProps) {
  const router = useCheckUpRouter();
  const [selected, setSelected] = useState<ProductItemProps[]>([]);

  const handleSubmit = () => {
    router.navigate(Page.PRODUCT_SLOTS, {
      patient,
      service,
      products: selected,
      elegibility,
      firstAppointmentDate,
      isFirstAppointment
    });
  };

  return (
    <ContainerPage childrenFooter={<ActionButton disable={selected.length === 0} handleActionButton={handleSubmit} />}>
      <Container>
        <HeadTitle title="Quais consultas deseja agendar? " goBack={router.goBack} />
        <ProductListMult
          products={service.products}
          setProductList={() => void 0}
          selected={selected}
          onChange={setSelected}
        />
      </Container>
    </ContainerPage>
  );
}
